import findIndex from "lodash/findIndex";
import {isNumber} from 'lodash'
import config from "@appConfig";
import { reactive } from 'vue'

const apiUrl = config.API_URL + '/clustering/';

const states = reactive({
    constants: {
        clusterResultId: -3
    },
    dragStartFolderId: null,
    nodes: [],
    nodeIds: [],
    cachedNodes: {},
    uid: null,
    selectNode: {},
    selectNodes: [],
    selectContextNode: {},
    isContext: false,
    breadcrumbs: [],
    setting: {},
    treeFilter: {},
    phraseMatches: null,
    settingViewCountWeight: {},
    countTitle: {
        keys_count: {
            title: 'Общее кол-во ключей',
            abbr: 'К-во'
        },
        max_key_ws: {
            title: 'Частотность главного ключа',
            abbr: 'ЧГК'
        },
        max_key_wsk: {
            title: 'Частотность главного ключа "!ws"',
            abbr: '[ЧГК]'
        },
        max_key_superwsk: {
            title: 'Частотность главного ключа "[!ws]"',
            abbr: '[ЧГК]'
        },
        ws_sum: {
            title: 'Суммарная частотность',
            abbr: '&sum;Ч'
        },
        wsk_sum: {
            title: 'Суммарная частотность "!ws"',
            abbr: '&sum;[Ч]'
        },
        superwsk_sum: {
            title: 'Суммарная частотность "[!ws]"',
            abbr: '&sum;[Ч]'
        },
    }
});

// getters
const getters = {
    constants: () => states.constants,
    dragStartFolderId: () => states.dragStartFolderId,
    uid: () => states.uid,
    nodeIds: () => states.nodeIds,
    selectNode: () => states.selectNode,
    selectNodes: () => states.selectNodes,
    selectContextNode: () => states.selectContextNode,
    isContext: () => states.isContext,
    setting: () => states.setting,
    treeFilter: () => states.treeFilter,
    phraseMatches: () => states.phraseMatches,
    cachedNodes: () => states.cachedNodes,
    countTitle: () => states.countTitle,
    nodes: () => {
        return states.nodeIds.map((ids) => {
            return states.cachedNodes[ids];
        });
    },
    settingViewCountWeight: () => {
        let result = {};

        let getWeigh = function (value) {
            const formattedValue = isNumber(value) ? value.formatMoney(0, ' ', ' ') : value;
            switch (formattedValue.length) {
                case 0:
                case 1:
                case 2:
                case 3:
                case 5:
                case 6:
                    return 27;
                case 7:
                case 8:
                case 9:
                    return 35;
                default:
                    return 50;
            }
        };

        for (let p in states.settingViewCountWeight) {
            result[p] = getWeigh(states.settingViewCountWeight[p]);
        }

        return result;
    },
    breadcrumbs: () => {
        if (Object.keys(states.selectNode).length > 0) {
            let getBreadcrumbs = function (node, data) {
                let findNode = states.cachedNodes[node.pid];
                if (findNode) {
                    data.push(findNode);
                    return getBreadcrumbs(findNode, data);
                }

                return data;
            };

            return getBreadcrumbs(states.selectNode, [states.selectNode]).reverse();
        }

        return [];
    }
};

// mutations
const mutations = {
    setDragStartFolderId(fid) {
        states.dragStartFolderId = fid;
    },
    setUid(uid) {
        states.uid = uid
    },
    setSetting(setting) {
        states.setting = setting
    },
    setTreeFilter(treeFilter) {
        states.treeFilter = treeFilter
    },
    setPhraseMatches(phraseMatches) {
        states.phraseMatches = phraseMatches
    },
    setNodesInfo({nodeIds, cachedNodes}) {
        let weightConfig = {};

        for (let p in states.setting.view.treeNodeName) {
            weightConfig[p] = 0;
        }

        for (let nodeId in cachedNodes) {
            let node = cachedNodes[nodeId]
            if (states.cachedNodes[nodeId]) {
                states.cachedNodes[nodeId].state.open = node.state.open;
                states.cachedNodes[nodeId].state.depth = node.state.depth;
                /*state.cachedNodes[nodeId].state.total = node.state.total;*/
                states.cachedNodes[nodeId].total_flatten = node.total_flatten;
                states.cachedNodes[nodeId].has_children = node.has_children;
                states.cachedNodes[nodeId].keys_count = node.keys_count;
                states.cachedNodes[nodeId].ws_sum = node.ws_sum;
                states.cachedNodes[nodeId].wsk_sum = node.wsk_sum;
                states.cachedNodes[nodeId].superwsk_sum = node.superwsk_sum;
                states.cachedNodes[nodeId].max_key_ws = node.max_key_ws;
                states.cachedNodes[nodeId].max_key_wsk = node.max_key_wsk;
                states.cachedNodes[nodeId].max_key_superwsk = node.max_key_superwsk;
                states.cachedNodes[nodeId].lock = node.lock;
                states.cachedNodes[nodeId].pid = node.pid;
                states.cachedNodes[nodeId].name = node.name;
            } else {
                states.cachedNodes[nodeId] = node;
            }

            for (let p in states.setting.view.treeNodeName) {
                if (node[p] >= weightConfig[p]) {
                    weightConfig[p] = node[p];
                }
            }
        }

        states.settingViewCountWeight = weightConfig;
        states.nodeIds = nodeIds;
    },
    setSelectNode(node) {
        states.selectNode = node;
    },
    setSelectNodes(node) {
        let index = findIndex(states.selectNodes, {id: node.id});
        if (index !== -1) {
            states.selectNodes.splice(index, 1);
        } else {
            states.selectNodes.push(node);
        }
    },
    setSelectNodesById(id) {
        let index = findIndex(states.selectNodes, {id: id});
        if (index !== -1) {
            states.selectNodes.splice(index, 1);
        } else {
            states.selectNodes.push(states.cachedNodes[id]);
        }
    },
    deleteSelectNodesById(id) {
        let index = findIndex(states.selectNodes, {id: id});
        if (index !== -1) {
            states.selectNodes.splice(index, 1);
        }
    },
    setSelectContextNode(node) {
        states.selectContextNode = node;
    },
    setIsContext(value) {
        states.isContext = value;
    },
    clearSelectNodes() {
        states.selectNodes = [];
    },
    clearSelectNode() {
        states.selectNode = {};
    },
};

export const store = {
    getters,
    mutations
};
